export default "__VITE_ASSET__xfjPmfS0__"